<template>
  <div>
    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
        <!--        <el-button v-permisaction="['config:userStatData:export']" icon="el-icon-download" size="mini" @click="exportData(2)">导出</el-button>-->
      </el-form-item>
    </el-form>
    <Charts ref="data" />
  </div>
</template>

<script>
import Charts from '@/components/Charts/Charts.vue'
import { getDauMauStat } from '@/api/statistics/user_remain'
import { dateStrTodate, getLastDates } from '@/utils'

export default {
  name: 'DauMau',
  components: { Charts },
  data() {
    return {
      loading: false,
      queryParams: {
        startDate: '',
        endDate: ''
      }
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
    this.getTables()
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      this.getTables()
    },
    getTables() {
      this.loading = true
      getDauMauStat(this.queryParams).then(res => {
        this.loading = false
        const obj = { legend: ['DAU/MAU'], series: [], xAxis: [] }
        const valArr = []
        if (res.data.data.length > 0) {
          const { data } = res.data
          for (const i in data) {
            const val = data[i]
            valArr.push(val.rate)
            obj.xAxis.push(dateStrTodate(val.date))
          }
        }

        const temp = {
          name: 'DAU/MAU',
          data: valArr,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top',
            formatter: '{c}'
          }
        }
        obj.series.push(temp)
        this.$refs.data.refresh(obj)
      })
    }
  }
}
</script>

<style scoped>

</style>
